import React from 'react';

export const videoSrc = 'https://www.youtube.com/embed/_rF41bS155k';

export const aquamationTitle = 'Aquamation';
export const aquamationContent = (
	<>
		<p>
			Some of our Lap of Love locations have begun offering “Aquamation" as an aftercare option. Below you will find more information on this
			unique cremation procedure.
		</p>
	</>
);

export const whatIsTitle = 'What is Aquamation?';
export const whatIsContent = (
	<>
		<p>
			Aquamation is a safe, natural and environmentally friendly alternative to flame-based cremation or burial. It produces no toxic air
			emissions and uses a fraction of the energy of traditional cremation. In fact, out of all the options available, Aquamation leaves the
			smallest carbon footprint on our planet.
		</p>
		<p>Aquamation is also known by the following terms: Bio-Cremation, Alkaline Hydrolysis or Green Cremation.</p>
	</>
);

export const howDoesTitle = 'How does Aquamation work?';
export const howDoesContent = (
	<>
		<p>
			Aquamation is a gentle, quiet, and eco-friendly process using a combination of flowing water and alkalinity to accelerate the natural
			course of tissue breakdown that occurs during burial in the earth. Because there is no burning in Aquamation, there are more remains left
			after the process has finished. This remaining compound is mostly made up of calcium from the body (bones, teeth, and other minerals).
			This “bone ash” is softer, whiter, and lighter than with traditional flame-based cremation.
		</p>
	</>
);

export const differenceTitle = 'What is the difference between Aquamation and other choices?';
export const differenceContent = (
	<>
		<p>
			Whether you choose burial, flame-based cremation, or Aquamation, the end result is the same; each body is eventually reduced to its basic
			elements of bone ash. The primary difference between burial, flame cremation, or Aquamation is the amount of time the process takes as
			well as the “catalyst” that supports the transition. Flame cremation creates smoke while the remaining by-product of Aquamation is made up
			of nutrients, amino acids and sugars.
		</p>
	</>
);
export const whatCanTitle = 'What can I expect?';
export const whatCanContent = (
	<>
		<p>
			We will make all the arrangements for aquamation and arrange for your pet’s delivery to the crematory. Your pet will be treated with care
			and dignity throughout the entire process. In about 10 – 14 days your pet will be safely delivered to your primary care veterinarian or
			securely shipped to your home. Your veterinarian can discuss the best option for you.
		</p>
		<p>
			As described above, Aquamation allows for a slightly larger quantity of bone ash when completed. Therefore, two pets of similar weight and
			build cremated two different ways will have differing amounts of remains (Aquamation will be more).
		</p>
	</>
);
